import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzEsa } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_ESA: Record<
  Exclude<PageIdWoofzEsa, PageIdWoofzEsa.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.MOTIVATION_ESA]: {
    id: PageId.MOTIVATION_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.YOUR_AGE_ESA]: {
    id: PageId.YOUR_AGE_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.ESA_LETTER]: {
    id: PageId.ESA_LETTER,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageId.ACCOMPANY_ESA]: {
    id: PageId.ACCOMPANY_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.HAPPINESS_ESA]: {
    id: PageId.HAPPINESS_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.SADNESS_ESA]: {
    id: PageId.SADNESS_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.TRY_ESA]: {
    id: PageId.TRY_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.FULL_SUPPORT_ESA]: {
    id: PageId.FULL_SUPPORT_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.EXPERT_ESA]: {
    id: PageId.EXPERT_ESA,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.PERSONALIZED_ESA]: {
    id: PageId.PERSONALIZED_ESA,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.MENTAL_HEALTH_ESA]: {
    id: PageId.MENTAL_HEALTH_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.SADNESS_LAST_WEEKS_ESA]: {
    id: PageId.SADNESS_LAST_WEEKS_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.ANGER_LAST_WEEKS_ESA]: {
    id: PageId.ANGER_LAST_WEEKS_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.WORRY_LAST_WEEKS_ESA]: {
    id: PageId.WORRY_LAST_WEEKS_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.AFRAID_LAST_WEEKS_ESA]: {
    id: PageId.AFRAID_LAST_WEEKS_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.SLEEP_LAST_WEEKS_ESA]: {
    id: PageId.SLEEP_LAST_WEEKS_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.NERVOUS_LAST_WEEKS_ESA]: {
    id: PageId.NERVOUS_LAST_WEEKS_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.MEMORY_LAST_WEEKS_ESA]: {
    id: PageId.MEMORY_LAST_WEEKS_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.FOCUS_ESA]: {
    id: PageId.FOCUS_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.EMOTIONAL_SCORE_ESA]: {
    id: PageId.EMOTIONAL_SCORE_ESA,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.DOG_NOTICE_UPSET_ESA]: {
    id: PageId.DOG_NOTICE_UPSET_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_NEXT_TO_YOU_ESA]: {
    id: PageId.DOG_NEXT_TO_YOU_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_SUPPORT_CUES_ESA]: {
    id: PageId.DOG_SUPPORT_CUES_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.STATS_ESA]: {
    id: PageId.STATS_ESA,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.DOG_BREED_ESA]: {
    id: PageId.DOG_BREED_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_AGE_ESA]: {
    id: PageId.DOG_AGE_ESA,
    headerId: HeaderId.TITLE_MENU,
  },
  [PageId.DOG_SIZE_ESA]: {
    id: PageId.DOG_SIZE_ESA,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_ESA]: {
    id: PageId.URGE_ESA,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.PREPARE_FLOW_ESA]: {
    id: PageId.PREPARE_FLOW_ESA,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.PLAN_ESA]: {
    id: PageId.PLAN_ESA,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.EMAIL_ESA]: {
    id: PageId.EMAIL_ESA,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.SUBSCRIPTIONS_ESA]: {
    id: PageId.SUBSCRIPTIONS_ESA,
  },
  [PageId.CANCEL_OFFER_ESA]: {
    id: PageId.CANCEL_OFFER_ESA,
  },
  [PageId.CHAT_UPSELL_ESA]: {
    id: PageId.CHAT_UPSELL_ESA,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_ESA]: {
    id: PageId.UPSELL_ESA,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_ESA]: {
    id: PageId.DOWNLOAD_ESA,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  // temp unused pages
  [PageId.INTRO_ESA]: {
    id: PageId.INTRO_ESA,
    headerId: HeaderId.TITLE_MENU,
  },
}
